import { render, staticRenderFns } from "./ProductsSelect.vue?vue&type=template&id=e7939cd6&"
import script from "./ProductsSelect.vue?vue&type=script&lang=js&"
export * from "./ProductsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports